import { render } from "./LotTrace.vue?vue&type=template&id=08b5cef2&scoped=true"
import script from "./LotTrace.vue?vue&type=script&lang=js"
export * from "./LotTrace.vue?vue&type=script&lang=js"

import "./LotTrace.vue?vue&type=style&index=0&id=08b5cef2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08b5cef2"]])

export default __exports__